<mat-card>
	<mat-card-header>
		<mat-card-title>
			Deleting {{students ? students.length: ''}} Child Enrollments
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
		</mat-card-title>
		<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
			<mat-icon>close</mat-icon>
		</button>
	</mat-card-header>

	<mat-card-content>

		<delete-child-enrollment-check *ngIf="!isLoading" [students]="students"
			(setDoneLoading)="setDoneLoading($event)"></delete-child-enrollment-check>

		<hr />
		<div class="row">
			<confirm-popover class="margin-bottom-xs" [buttonType]="'string'" [color]="'warn'"
				[popoverMsg]="'Confirm Delete'" [popoverConfirmText]="'Delete'" [buttonTxt]="'Delete'"
				[popoverConfirmColor]="'warn'" (onConfirm)="confirm()"
				[disabled]="!doneLoading || isDeleting || (msg && msg.SUCCESS!)">
			</confirm-popover>

			<button type="button" mat-icon-button *ngIf="isDeleting">
				<mat-icon>
					<mat-spinner diameter="20"> </mat-spinner>
				</mat-icon>
			</button>
		</div>
		<app-msg [msg]="msg" *ngIf="msg"></app-msg>
	</mat-card-content>
</mat-card>